module.exports = __webpack_public_path__ + "static/img/sanction.d8f2b921.gif";